



























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { AccomodationUnitTypesWithDetailsView } from "@/shared/models/accomodationUnitTypesWithDetailsView";
import RatingInput from "@/components/misc/RatingInput.vue";
import { CategoriesEnum } from "@/shared/models/enums.type"

@Component({
  components: {
    RatingInput,
  },
})
export default class AccomodationUnitTypeForm extends Vue {
  @Prop()
  model?: AccomodationUnitTypesWithDetailsView;
  @Prop()
  readonly?: boolean;

  get category() {
    if (this.model){
      if (this.model.categoryId === CategoriesEnum.Empty){
        return 0;
      }
      return this.model.categoryId + 1;
    }
    return 0;
  }
  set category(val: number) {
    if (this.model && (val === 0 || (val === 1 && this.model.categoryId === CategoriesEnum.Star2))){
      this.model.categoryId = CategoriesEnum.Empty
    }
    else
    {
      if (this.model){
        this.model.categoryId = val - 1;
        if (val === 1){
          this.$nextTick(() => {
            if(this.model) this.model.categoryId = CategoriesEnum.Star2;
          });
        }
      }
    }
  }
  get propertyCategory() {
    return this.model ? this.model.categoryId + 1 : CategoriesEnum.Star3;
  }
  set propertyCategory(val: number) {
    if (this.model) {
      this.model.propertyCategoryId = val - 1;
      if (val < 2) {
        this.$nextTick(() => {
          if (this.model) this.model.propertyCategoryId = CategoriesEnum.Star2;
        });
      }
    }
  }
}
